import { useState } from 'react';
import { fetchSatelliteData } from '../../../engine/satelliteMock';

export function SatelliteView() {
  const [lat, setLat] = useState(47.5);
  const [lon, setLon] = useState(19.0);
  const data = fetchSatelliteData(lat, lon);
  return (
    <div className="space-y-2 border border-evat-gold/40 rounded p-3">
      <div className="font-orbitron text-evat-gold">Satellite Mock</div>
      <div className="flex gap-2 text-sm">
        <label className="flex items-center gap-2">Lat<input type="number" step="0.1" value={lat} onChange={(e)=>setLat(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/></label>
        <label className="flex items-center gap-2">Lon<input type="number" step="0.1" value={lon} onChange={(e)=>setLon(Number(e.target.value))} className="bg-black border border-evat-neon text-evat-neon rounded px-2 py-1 w-24"/></label>
      </div>
      <div className="text-sm text-neutral-300">Land use: <span className="text-evat-neon">{data.landUseType}</span></div>
      <div className="text-sm text-neutral-300">Green area: <span className="text-evat-gold">{data.greenAreaPercent}%</span></div>
      <div className="text-sm text-neutral-300">Solar exposure: <span className="text-evat-gold">{data.solarExposureHours} h</span></div>
    </div>
  );
}

export default SatelliteView;



















